"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveReadAction = exports.useReadCollectionDialog = void 0;
const abortable_fetch_1 = require("../../../utils/abortable-fetch");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
function useReadCollectionDialog(getUrl) {
    const callApi = (0, event_callback_hook_1.useEventCallback)((id) => {
        return (0, abortable_fetch_1.abortableFetch)(`${getUrl(id)}`, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
        });
    });
    return {
        callApi,
    };
}
exports.useReadCollectionDialog = useReadCollectionDialog;
function resolveReadAction(props) {
    return {
        useApi: useReadCollectionDialog,
        ...props,
    };
}
exports.resolveReadAction = resolveReadAction;
//# sourceMappingURL=read-collection-hook.js.map